import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import App from './App'
import store from '@/core/store'

import './index.sass'

if (window.location.origin.includes('boxes.im') || window.location.origin.includes('boxes.im')) {
  Sentry.init({
    dsn: 'https://eeed826c7bc74ec5a1ea0d76eae9a29f@o1179805.ingest.sentry.io/6292092',
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
  })
}

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
  ,
  document.getElementById('root')
)
